import { Text } from '@gympass/yoga';
import { Bike } from '@yoga-inner/illustrations';
import tokens from '@gympass/yoga-tokens';

import Template from 'components/Template';

export default function Error() {
  return (
    <Template>
      <Bike />
      <Text.Display4 marginBottom={tokens.spacing.xsmall}>
        Something went wrong
      </Text.Display4>
      <Text.Medium light>Please try again later</Text.Medium>
    </Template>
  );
}
